module.exports = __webpack_public_path__ + "media/images/website_second-9221bd75ab9a26b556e041b00173cd3c.svg";